export default __webpack_public_path__ + "static/media/washupStampNewsBanner.50ccb5e1.png";